import { useQuery } from "react-query";
import inventoryClient from "../clients/inventoryClient";

function useSpecRecipe(recipeId) {
  const queryReturnValues = useQuery(
    ["spec-recipe", { recipeId }],
    inventoryClient.getSpecRecipeDetails
  );

  return queryReturnValues;
}

export default useSpecRecipe;
